import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ICreateTermoUsoUserAcceptRequest } from 'src/app/services/TermoUsoService/termoUso.model';
import { TermoUsoService } from 'src/app/services/TermoUsoService/termoUso.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  constructor(
    private termoUsoService: TermoUsoService,
    private authService: AuthService,
    private appExport: AppExportBase64
  ) {}

  isVisibleTerm() {
    this.termoUsoService.GetVerifyTermoUserLastVersionByUserId().subscribe({
      next: response => {
        if (!response.FL_USO_LAST && !response.FL_CSNT_LAST) this.viewAlert();
      },
      error: () => {}
    });
  }

  viewTermoUso(tipoTermo: number) {
    this.termoUsoService.GetLastTermoVersionByTipo(tipoTermo).subscribe({
      next: response => {
        this.appExport.guiaPdf(response.File.Base64Content);
      }
    });
  }

  viewAlert() {
    Swal.fire({
      title: 'Atenção',
      html: `
      <p>
        Leia o <a href="#" id="link-termo-uso">termo de uso</a> e <a href="#" id="link-termo-consentimento">termo de consentimento</a>, ao confirmar poderá utilizar o sistema.
      </p>
    `,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      confirmButtonColor: 'green',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: 'red',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton()!;
        let confirmTermoUso: boolean = false;
        let confirmConsentimento: boolean = false;

        confirmButton.disabled = true;

        const linkUso = document.getElementById('link-termo-uso');
        const linkConsentimento = document.getElementById(
          'link-termo-consentimento'
        );

        const tryEnableConfirm = () => {
          if (confirmTermoUso && confirmConsentimento) {
            confirmButton.disabled = false;
          }
        };

        if (linkUso)
          linkUso.addEventListener('click', event => {
            event.preventDefault();
            this.viewTermoUso(1);
            confirmTermoUso = true;
            
            tryEnableConfirm();
          });

        if (linkConsentimento)
          linkConsentimento.addEventListener('click', event => {
            event.preventDefault();
            this.viewTermoUso(2);
            confirmConsentimento = true;

            tryEnableConfirm();
          });

        if (confirmTermoUso && confirmConsentimento)
          confirmButton.disabled = false;
      }
    }).then(result => {
      if (result.isDismissed) this.authService.logout();

      if (result.isConfirmed) this.onUserAccept();
    });
  }

  onUserAccept() {
    this.termoUsoService.GetLastTermoVersionByTipo(1).subscribe({
      next: response => {
        const requestCreateTermoUsoUserAccept: ICreateTermoUsoUserAcceptRequest =
          {
            TermoVersaoId: response.TermoId,
            UserBrowser: navigator.userAgent,
            UserIP: localStorage.getItem('ipv4') ?? '0.0.0.0',
            UserSO: /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
              ? 'mobile'
              : 'desktop'
          };

        this.termoUsoService
          .CreateTermoUsoUserAccept(requestCreateTermoUsoUserAccept)
          .subscribe();
      }
    });
  }

  ngOnInit(): void {
    this.isVisibleTerm();
  }

  ngAfterViewInit(): void {}
}
